import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';
import {
  getApiERxUserNotificationCounts,
} from 'endpoints';
import {
  ERxNotificationsCountResponseDTO,
} from 'dtos';

export default function useDosespotNotifications(): UseQueryResult<
  ERxNotificationsCountResponseDTO, Error> {
  const userInfo = useUserInfo();

  return useQuery<ERxNotificationsCountResponseDTO, Error>({
    queryKey: ['dosespot-notiifications'],
    queryFn: getApiERxUserNotificationCounts,
    enabled: userInfo?.flags?.haseRxCredentials ?? false,
  });
}
